import { InstallmentFeesFields } from '@/components/InstallmentFeesFields';
import React, { Fragment } from 'react';
import { Container, FormGroup } from 'reactstrap';
import { InputText } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { FormInputNameFee } from '../../types';

interface StateProps {
  formData: FormData;
  formErrors: FormErrors;
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
}

type Props = StateProps & DispatchProps;

export const FeeContent: React.FC<Props> = ({
  formData,
  onChangeFormInput,
  formErrors,
}): JSX.Element => (
  <Fragment>
    <Container className="mainContainer" fluid={true}>
      <div className="container-event mb-4">
        <h5 className="mb-2 border-bottom-title mb-5">Taxas dos Ingressos</h5>

        <p style={{ fontSize: '21px', fontWeight: '500' }}>Venda física</p>

        <FormGroup>
          <InputText
            name="ticketPhysicalSaleDebit"
            label="Débito"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.ticketPhysicalSaleDebit]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.ticketPhysicalSaleDebit)(e.target.value)
            }
            error={formErrors.ticketPhysicalSaleDebit && formErrors.ticketPhysicalSaleDebit[0]}
          />
          <InputText
            name="ticketPhysicalSaleCredit"
            label="Crédito"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.ticketPhysicalSaleCredit]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.ticketPhysicalSaleCredit)(e.target.value)
            }
            error={formErrors.ticketPhysicalSaleCredit && formErrors.ticketPhysicalSaleCredit[0]}
          />
          <InputText
            name="ticketPhysicalSalePix"
            label="PIX"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.ticketPhysicalSalePix]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.ticketPhysicalSalePix)(e.target.value)
            }
            error={formErrors.ticketPhysicalSalePix && formErrors.ticketPhysicalSalePix[0]}
          />
          <InputText
            name="ticketPhysicalSaleAdministrateTax"
            label="Taxa administrativa"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.ticketPhysicalSaleAdministrateTax]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.ticketPhysicalSaleAdministrateTax)(e.target.value)
            }
            error={
              formErrors.ticketPhysicalSaleAdministrateTax &&
              formErrors.ticketPhysicalSaleAdministrateTax[0]
            }
          />
        </FormGroup>
        <div className="d-flex">
          <InstallmentFeesFields
            name="ticketPhysicalSaleInstallmentFees"
            value={formData.ticketPhysicalSaleInstallmentFees}
            onChange={onChangeFormInput('ticketPhysicalSaleInstallmentFees')}
            error={formErrors.ticketPhysicalSaleInstallmentFees?.[0]}
          />
        </div>

        <p style={{ fontSize: '21px', fontWeight: '500' }}>Venda e-commerce</p>

        <FormGroup>
          <InputText
            name="ticketWebsiteSaleBankSlip"
            label="Boleto"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.ticketWebsiteSaleBankSlip]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.ticketWebsiteSaleBankSlip)(e.target.value)
            }
            error={formErrors.ticketWebsiteSaleBankSlip && formErrors.ticketWebsiteSaleBankSlip[0]}
          />
          <InputText
            name="ticketWebsiteSaleCredit"
            label="Crédito"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.ticketWebsiteSaleCredit]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.ticketWebsiteSaleCredit)(e.target.value)
            }
            error={formErrors.ticketWebsiteSaleCredit && formErrors.ticketWebsiteSaleCredit[0]}
          />
          <InputText
            name="ticketWebsiteSalePix"
            label="PIX"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.ticketWebsiteSalePix]}
            placeholder="Ex: 1"
            onChange={e => onChangeFormInput(FormInputNameFee.ticketWebsiteSalePix)(e.target.value)}
            error={formErrors.ticketWebsiteSalePix && formErrors.ticketWebsiteSalePix[0]}
          />
          <InputText
            name="ticketWebsiteSaleAdministrateTax"
            label="Taxa administrativa"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.ticketWebsiteSaleAdministrateTax]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.ticketWebsiteSaleAdministrateTax)(e.target.value)
            }
            error={
              formErrors.ticketWebsiteSaleAdministrateTax &&
              formErrors.ticketWebsiteSaleAdministrateTax[0]
            }
          />
        </FormGroup>
        <div className="d-flex">
          <InstallmentFeesFields
            name="ticketWebsiteSaleInstallmentFees"
            value={formData.ticketWebsiteSaleInstallmentFees}
            onChange={onChangeFormInput('ticketWebsiteSaleInstallmentFees')}
            error={formErrors.ticketWebsiteSaleInstallmentFees?.[0]}
          />
        </div>
      </div>

      <div className="container-event mb-4">
        <h5 className="mb-2 border-bottom-title mb-5">Taxas dos Produtos</h5>

        <p style={{ fontSize: '21px', fontWeight: '500' }}>Venda física</p>

        <FormGroup>
          <InputText
            name="productPhysicalSaleDebit"
            label="Débito"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.productPhysicalSaleDebit]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.productPhysicalSaleDebit)(e.target.value)
            }
            error={formErrors.productPhysicalSaleDebit && formErrors.productPhysicalSaleDebit[0]}
          />
          <InputText
            name="productPhysicalSaleCredit"
            label="Crédito"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.productPhysicalSaleCredit]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.productPhysicalSaleCredit)(e.target.value)
            }
            error={formErrors.productPhysicalSaleCredit && formErrors.productPhysicalSaleCredit[0]}
          />
          <InputText
            name="productPhysicalSalePix"
            label="PIX"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.productPhysicalSalePix]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.productPhysicalSalePix)(e.target.value)
            }
            error={formErrors.productPhysicalSalePix && formErrors.productPhysicalSalePix[0]}
          />
          <InputText
            name="productPhysicalSaleAdministrateTax"
            label="Taxa administrativa"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.productPhysicalSaleAdministrateTax]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.productPhysicalSaleAdministrateTax)(e.target.value)
            }
            error={
              formErrors.productPhysicalSaleAdministrateTax &&
              formErrors.productPhysicalSaleAdministrateTax[0]
            }
          />
        </FormGroup>
        <div className="d-flex">
          <InstallmentFeesFields
            name="productPhysicalSaleInstallmentFees"
            value={formData.productPhysicalSaleInstallmentFees}
            onChange={onChangeFormInput('productPhysicalSaleInstallmentFees')}
            error={formErrors.productPhysicalSaleInstallmentFees?.[0]}
          />
        </div>

        <p style={{ fontSize: '21px', fontWeight: '500' }}>Venda e-commerce</p>

        <FormGroup>
          <InputText
            name="productWebsiteSaleBankSlip"
            label="Boleto"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.productWebsiteSaleBankSlip]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.productWebsiteSaleBankSlip)(e.target.value)
            }
            error={
              formErrors.productWebsiteSaleBankSlip && formErrors.productWebsiteSaleBankSlip[0]
            }
          />
          <InputText
            name="productWebsiteSaleCredit"
            label="Crédito"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.productWebsiteSaleCredit]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.productWebsiteSaleCredit)(e.target.value)
            }
            error={formErrors.productWebsiteSaleCredit && formErrors.productWebsiteSaleCredit[0]}
          />
          <InputText
            name="productWebsiteSalePix"
            label="PIX"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.productWebsiteSalePix]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.productWebsiteSalePix)(e.target.value)
            }
            error={formErrors.productWebsiteSalePix && formErrors.productWebsiteSalePix[0]}
          />
          <InputText
            name="productWebsiteSaleAdministrateTax"
            label="Taxa administrativa"
            className="w-input-sm"
            addon="%"
            maxLength={5}
            value={formData[FormInputNameFee.productWebsiteSaleAdministrateTax]}
            placeholder="Ex: 1"
            onChange={e =>
              onChangeFormInput(FormInputNameFee.productWebsiteSaleAdministrateTax)(e.target.value)
            }
            error={
              formErrors.productWebsiteSaleAdministrateTax &&
              formErrors.productWebsiteSaleAdministrateTax[0]
            }
          />
        </FormGroup>
        <div className="d-flex">
          <InstallmentFeesFields
            name="productWebsiteSaleInstallmentFees"
            value={formData.productWebsiteSaleInstallmentFees}
            onChange={onChangeFormInput('productWebsiteSaleInstallmentFees')}
            error={formErrors.productWebsiteSaleInstallmentFees?.[0]}
          />
        </div>
      </div>
    </Container>
  </Fragment>
);
